/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the current session authenticated at the identity provider
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type SessionMethodEnum = 'native' | 'federated' | 'unknown';

export const SessionMethodEnum = {
    Native: 'native' as SessionMethodEnum,
    Federated: 'federated' as SessionMethodEnum,
    Unknown: 'unknown' as SessionMethodEnum
};

marker('native');
marker('federated');
marker('unknown');

